import { render, staticRenderFns } from "./SysMessageTemplateList.vue?vue&type=template&id=1a1bc97e&scoped=true&"
import script from "./SysMessageTemplateList.vue?vue&type=script&lang=js&"
export * from "./SysMessageTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./SysMessageTemplateList.vue?vue&type=style&index=0&id=1a1bc97e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1bc97e",
  null
  
)

export default component.exports